import React, { useEffect, useRef, useState } from "react";
import { Box } from "grommet";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";
import { Paths as AdminPath } from "./components/paths/Path";
import SidebarItem from "./components/sidebar-item/SidebarItem";
import { useUser } from "../context/User/UserContext";
import { EmsPaths } from "./components/paths/EmsPath";
import { SuperAdminPath } from "./components/paths/SuperAdminPath";
import UserCardComponent from "../body/screens/MedicalEmergenciesMainScreen/common/UserCard/UserCard";
import { Auth } from "aws-amplify";
import { CoordinatorPath } from "./components/paths/CoordinatorPath";
import navigationArrowUp from '../../../assets/arrow_circle_up.svg';
import navigationArrowDown from '../../../assets/arrow_circle_down.svg';
import { useInAppNotification } from "../context/InAppNotificationContext/InAppNotificationContext";
import { observer } from 'mobx-react';
import { useStore } from "../../../Hooks/useStore";
import { runInAction } from "mobx";
import { Mixpanel } from "../../../util/Helper";
import usersService from "../body/screens/IAM/Users/users.service";
import { SkaliPaths } from "./components/paths/SkaliAdminPath";

const Sidebar = observer(() => {
  const navigate = useNavigate();
  const { rootStore } = useStore();
  const menuElement = useRef(null);
  const sidebarContainerRef = useRef(null);

  const { setUser, user } = useUser();
  const [isScrollable, setIsScrollable] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [duplicatepath, setduplicatepath] = useState(false);

  const isSuperAdmin = user?.roleLabel?.toLowerCase() === "superadmin";

  useEffect(() => {
    const checkScrollable = () => {
      const sidebarContainer = sidebarContainerRef.current;
      const menu = menuElement.current;
      if (sidebarContainer && menu) {
        setIsScrollable(menu.scrollWidth > sidebarContainer.clientWidth);
        setIsScrolled(menu.scrollLeft > 0);
      }
    };

    const handleScroll = () => {
      const menu = menuElement.current;
      if (menu) {
        setIsScrolled(menu.scrollLeft > 0);
      }
    };

    const menu = menuElement.current;
    if (menu) {
      menu.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", checkScrollable);
      checkScrollable();

      if (isSuperAdmin) {
        setTimeout(() => {
          menu.scrollLeft = menu.scrollWidth / 2;
        }, 100);
      }
    }

    return () => {
      if (menu) {
        menu.removeEventListener("scroll", handleScroll);
      }
      window.removeEventListener("resize", checkScrollable);
    };
  }, [isSuperAdmin]);

  const handleScrollToTop = () => {
    const menu = menuElement.current;
    if (menu) {
      menu.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleScrollToBottom = () => {
    const menu = menuElement.current;
    if (menu) {
      menu.scrollTo({ top: menu.scrollHeight, behavior: "smooth" });
    }
  };

  const handleNavigationArrowClick = () => {
    if (isScrolled) {
      handleScrollToTop();
    } else {
      handleScrollToBottom();
    }
  };

  const handleLoopingScroll = () => {
    if (!isSuperAdmin) return;

    const menu = menuElement.current;
    if (!menu) return;

    const scrollLeft = menu.scrollLeft;
    const scrollWidth = menu.scrollWidth;
    const containerWidth = menu.offsetWidth;

    if (scrollLeft + containerWidth >= scrollWidth - 5) {
      menu.scrollLeft = scrollWidth / 2 - containerWidth;
    }

    if (scrollLeft <= 5) {
      menu.scrollLeft = scrollWidth / 2;
    }
  };

  useEffect(() => {
    if (!user) {
      const userInfo = JSON.parse(localStorage.getItem("userinfo"));
      if (userInfo) {
        setUser(userInfo);
      }
    }

    const connection = setInterval(() => {
      runInAction(() => {
        rootStore.emsStore.networkStatus = navigator.onLine;
      });
    }, 3000);

    async function getUserOrganization(user) {
      const organizationName = await usersService.getDeviceToken(user.username);

      switch (user.roleLabel.toLowerCase()) {
        case "ems":
        case "crew":
          rootStore.emsStore.changePaths(EmsPaths);
          break;
        case "coordinator":
          rootStore.emsStore.changePaths(CoordinatorPath);
          break;
        case "admin":
          if (organizationName.organization.name === "Skali" && organizationName.organization.id === 23367) {
            rootStore.emsStore.changePaths(SkaliPaths);
          } else {
            rootStore.emsStore.changePaths(AdminPath);
          }
          break;
        case "superadmin":
          rootStore.emsStore.changePaths(SuperAdminPath);
          break;
        default:
          rootStore.emsStore.changePaths(EmsPaths);
      }
    }

    if (user) {
      getUserOrganization(user);
    } else {
      const userInfo = JSON.parse(localStorage.getItem("userinfo"));
      if (userInfo) {
        setUser(userInfo);
        getUserOrganization(userInfo);
      }
    }

    return () => clearInterval(connection);
  }, [user, rootStore.emsStore.getNetworkValue]);



  return (
    <Box className="nav-sidebar-container" ref={sidebarContainerRef}>
      <div
        className={`menus ${!isSuperAdmin ? "spread" : ""} ${isScrollable ? "scrollable" : "scrollable"}`}
        ref={menuElement}
        onScroll={duplicatepath ? handleLoopingScroll : undefined}
      >
        {(duplicatepath
          ? [...rootStore.emsStore.getPaths, ...rootStore.emsStore.getPaths]
          : rootStore.emsStore.getPaths
        ).map((item, index) => (
          <SidebarItem
            key={`${item.path}-${index}`}
            item={item}
            onClickHandler={(path, submenu = false, menuName = "") => {
              if (user?.name) {
                Mixpanel.track("web_sidebar_menu_click", {
                  "Menu Name": submenu ? item.label : menuName,
                  name: user?.name,
                });
              }
              navigate(path);
            }}
          />
        ))}
      </div>
      {isScrollable && (
        <Box className="navigation-arrow-outer" onClick={handleNavigationArrowClick}>
          {/* <img src={isScrolled ? navigationArrowUp : navigationArrowDown} alt="navigation arrow" /> */}
        </Box>
      )}
    </Box>
  );
});

export default Sidebar;
